// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tips-info {\n  line-height: 18px;\n  color: #c0c4cc;\n  font-size: 12px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
